var _Path, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgShuffle = function SvgShuffle(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "shuffle_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#shuffle_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "m9.262 10.296-4.38-4.388a.686.686 0 0 1-.217-.518c0-.206.073-.382.218-.527a.702.702 0 0 1 .517-.207c.206 0 .379.069.517.207l4.389 4.389-1.044 1.044ZM15 19.75a.726.726 0 0 1-.534-.216.727.727 0 0 1-.216-.534c0-.213.072-.391.216-.535A.726.726 0 0 1 15 18.25h2.215l-3.511-3.512 1.07-1.069 3.476 3.477V15c0-.213.072-.39.216-.534A.726.726 0 0 1 19 14.25c.213 0 .391.072.535.216a.726.726 0 0 1 .215.534v3.846c0 .256-.087.47-.26.644a.875.875 0 0 1-.644.26H15Zm-10.127-.623a.717.717 0 0 1-.217-.527c0-.206.072-.382.217-.527L17.196 5.75H15a.726.726 0 0 1-.534-.216A.726.726 0 0 1 14.25 5c0-.213.072-.391.216-.535A.726.726 0 0 1 15 4.25h3.846c.256 0 .47.087.644.26.173.173.26.388.26.644V9c0 .212-.072.39-.216.534A.726.726 0 0 1 19 9.75a.725.725 0 0 1-.535-.216A.726.726 0 0 1 18.25 9V6.804L5.927 19.127a.717.717 0 0 1-.527.217.717.717 0 0 1-.527-.217Z",
    fill: "currentColor"
  }))));
};
export default SvgShuffle;